import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as agentAssignment from '../agent-assignment'
import * as apps from '../apps'
import * as contexts from '../contexts'
import * as tenants from '../tenants'
import * as zones from '../zones'

import { Api } from './api'
import * as effects from './effects'
import type { TypeParams } from './types'

/**
 * Provides a collection of user-to-agent assignments for Admin Center Agents tabs.
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Collection extends ec.Collection<TypeParams> {
  constructor() {
    // DO NOT REMOVE THIS
    // NOTE: Prevents a runtime error during initialization of entity
    // collections. This is necessary because the agent assignments effect
    // relies on tenant, zone, and app context.
    ngCore.inject(tenants.Collection)
    ngCore.inject(zones.Collection)
    ngCore.inject(apps.Collection)
    // NOTE: Important to be after injecting collections above
    const _contexts = ngCore.inject(contexts.Feature)
    const _agentAssignmentFeature = ngCore.inject(agentAssignment.Feature)

    super({
      api: ngCore.inject(Api),
      identify: entry => entry.id,
      name: ec.Name.Dynamic.from('AgentAssignment'),
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory<TypeParams>(collection => ({
            rowConfig: ({ entity }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-close atn-red',
                  onClick: () => {
                    _agentAssignmentFeature.actions.markUserForUnassignment
                      .from(
                        `AgentAssignment.Table.Row-${entity.id}.Icons.Unassign.Clicked`,
                      )
                      .dispatch({
                        agentId: entity.agentId,
                        user: {
                          id: entity.userId,
                          name: entity.userName,
                        },
                      })
                  },
                },
              ],
            }),
          })),
        ],
      },
    })

    this.feature.registerEffects(
      effects.setFilters(this, _contexts),
      effects.refreshOnAgentAssignmentSuccess(this, _agentAssignmentFeature),
    )
  }
}
